export const categories = [
  { slug: 'romance', name: '恋爱言情', icon: 'ri-heart-line', count: 1280 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 956 },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', count: 843 },
  { slug: 'drama', name: '都市生活', icon: 'ri-building-line', count: 721 },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 634 },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 512 },
  { slug: 'historical', name: '历史古风', icon: 'ri-book-open-line', count: 398 },
  { slug: 'bl', name: 'BL专区', icon: 'ri-user-heart-line', count: 467 },
  { slug: 'gl', name: 'GL专区', icon: 'ri-women-line', count: 289 },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line', count: 1560 },
];

export const comics = [
  {
    id: 1,
    title: '女神降临',
    author: '猫咪',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20with%20long%20dark%20hair%20looking%20into%20a%20mirror%20with%20makeup%20surprised%20expression%20soft%20warm%20lighting%20romantic%20atmosphere%20clean%20cream%20background%20delicate%20lineart%20pastel%20tones%20webtoon%20style&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    views: 32800000,
    chapters: 256,
    status: 'completed',
    description: '讲述了一个因外貌自卑的女孩通过化妆技巧彻底改变人生的故事。当她遇到学校里最帅的两个男生后，她必须在真实自我和精心打造的完美形象之间做出选择。',
    tags: ['恋爱', '校园', '逆袭', '治愈'],
    updatedAt: '2026-06-28',
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20male%20hunter%20with%20dark%20purple%20energy%20aura%20surrounding%20him%20black%20combat%20outfit%20intense%20gaze%20dramatic%20lighting%20action%20fantasy%20theme%20clean%20dark%20gradient%20background%20powerful%20stance%20webtoon%20art%20style&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    rating: 9.8,
    views: 52000000,
    chapters: 179,
    status: 'completed',
    description: '在一个连接异次元的"门"突然出现的世界里，最弱猎人成振宇在一次几乎致命的双重地牢探险后，获得了独一无二的"系统"能力，从此踏上成为最强猎人的征途。',
    tags: ['热血', '系统', '升级', '战斗'],
    updatedAt: '2026-07-01',
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20holding%20a%20glowing%20book%20with%20mystical%20symbols%20floating%20around%20him%20apocalyptic%20cityscape%20background%20warm%20golden%20and%20teal%20color%20scheme%20dramatic%20fantasy%20atmosphere%20webtoon%20art%20style%20clean%20illustration&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    rating: 9.7,
    views: 41000000,
    chapters: 210,
    status: 'ongoing',
    description: '普通上班族金独子是他追了十多年的网络小说《在灭亡世界生存的三种方法》的唯一读者。当小说中的世界变成现实时，他利用自己对这个世界的了解开始了生存之旅。',
    tags: ['奇幻', '末世', '系统', '生存'],
    updatedAt: '2026-07-03',
  },
  {
    id: 4,
    title: '谁让我是绝世小可爱',
    author: '流川',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20girl%20with%20pink%20cheeks%20and%20big%20sparkling%20eyes%20wearing%20a%20school%20uniform%20surrounded%20by%20floating%20hearts%20and%20flowers%20soft%20pastel%20pink%20background%20romantic%20comedy%20vibe%20webtoon%20art%20style&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    rating: 9.3,
    views: 25600000,
    chapters: 189,
    status: 'ongoing',
    description: '全校最受欢迎的校草突然对平凡女生展开热烈追求，而这一切都源于一个神秘的手机应用。当手机里的虚拟男友变成现实，甜蜜又搞笑的校园恋爱故事就此展开。',
    tags: ['恋爱', '校园', '甜宠', '搞笑'],
    updatedAt: '2026-07-02',
  },
  {
    id: 5,
    title: '剑尊归来',
    author: '李玄',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Martial%20arts%20Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20hanbok%20holding%20a%20glowing%20sword%20with%20cherry%20blossom%20petals%20floating%20around%20ancient%20temple%20background%20vibrant%20red%20and%20gold%20accents%20epic%20atmosphere%20webtoon%20art&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    rating: 9.6,
    views: 38000000,
    chapters: 145,
    status: 'ongoing',
    description: '一代剑尊在飞升失败后，灵魂回到了自己最落魄的青少年时期。带着前世的记忆和武学修为，他决心重写命运，向曾经迫害他的人复仇，守护自己珍视的一切。',
    tags: ['武侠', '重生', '复仇', '热血'],
    updatedAt: '2026-07-01',
  },
  {
    id: 6,
    title: '她与野兽',
    author: '苏暖',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20woman%20with%20silver%20hair%20standing%20beside%20a%20majestic%20white%20wolf%20in%20a%20mystical%20forest%20with%20glowing%20mushrooms%20ethereal%20moonlight%20atmosphere%20elegant%20art%20style%20cool%20silver%20tones&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    rating: 9.4,
    views: 19500000,
    chapters: 132,
    status: 'ongoing',
    description: '被族人遗弃在禁忌森林的女孩，被一只神秘的白色巨兽救下并抚养长大。十年后，一位来自王都的骑士闯入森林，揭开了关于诅咒、王国和少女身世的惊天秘密。',
    tags: ['奇幻', '诅咒', '冒险', '治愈'],
    updatedAt: '2026-06-30',
  },
  {
    id: 7,
    title: '秘密课堂',
    author: '夏目',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20professional%20woman%20in%20elegant%20office%20attire%20standing%20in%20a%20classroom%20with%20sunlight%20streaming%20through%20windows%20warm%20golden%20hour%20lighting%20sophisticated%20atmosphere%20clean%20art%20style&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    rating: 9.2,
    views: 22300000,
    chapters: 167,
    status: 'ongoing',
    description: '一位顶级企业培训师隐藏真实身份来到一所普通高中任教。在与学生们的相处中，她发现了这所学校背后隐藏的教育腐败问题，决定用自己的方式改变一切。',
    tags: ['都市', '职场', '成长', '励志'],
    updatedAt: '2026-07-02',
  },
  {
    id: 8,
    title: '幽灵医生',
    author: '朴俊',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20doctor%20in%20white%20coat%20standing%20in%20a%20dark%20hospital%20corridor%20with%20eerie%20green%20fluorescent%20lighting%20one%20eye%20glowing%20supernatural%20thriller%20atmosphere%20suspenseful%20mood%20clean%20illustration&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    rating: 9.1,
    views: 18700000,
    chapters: 98,
    status: 'ongoing',
    description: '天才外科医生在一次医疗事故后获得了看见幽灵的能力。他发现自己工作的医院里徘徊着许多未能安息的灵魂，而每一条幽灵都指向医院深处一个被掩盖了数十年的黑暗秘密。',
    tags: ['悬疑', '医疗', '超自然', '推理'],
    updatedAt: '2026-06-29',
  },
  {
    id: 9,
    title: '社内恋爱',
    author: '白桃',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Office%20romance%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20man%20in%20business%20suit%20and%20a%20pretty%20woman%20in%20office%20attire%20sharing%20a%20coffee%20moment%20in%20modern%20office%20setting%20warm%20ambient%20lighting%20romantic%20tension%20webtoon%20style&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    views: 16500000,
    chapters: 112,
    status: 'ongoing',
    description: '公司里人人畏惧的冷面上司和新来的实习生被迫一起负责一个重要项目。工作中的朝夕相处让两人逐渐打破了对彼此的刻板印象，一段办公室恋情就此悄然展开。',
    tags: ['恋爱', '职场', '甜宠', '搞笑'],
    updatedAt: '2026-07-03',
  },
  {
    id: 10,
    title: '恶魔的契约',
    author: '黑暗工坊',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20man%20with%20red%20eyes%20and%20black%20wings%20making%20a%20pact%20with%20a%20young%20woman%20gothic%20castle%20background%20crimson%20and%20black%20color%20scheme%20dramatic%20supernatural%20atmosphere%20intricate%20art&width=800&height=1067&seq=comic-cover-10&orientation=portrait',
    rating: 9.5,
    views: 29800000,
    chapters: 201,
    status: 'ongoing',
    description: '为了拯救病危的妹妹，贫穷的女孩与一位神秘恶魔签订了契约。她必须完成恶魔指定的七项任务，但在执行任务的过程中，她逐渐发现这位恶魔似乎并非表面看起来那么简单。',
    tags: ['奇幻', '契约', '暗黑', '冒险'],
    updatedAt: '2026-07-01',
  },
  {
    id: 11,
    title: '甜蜜暴击',
    author: '草莓酱',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20style%20illustration%20of%20a%20girl%20with%20chubby%20cheeks%20holding%20a%20giant%20lollipop%20with%20exaggerated%20comical%20expression%20bright%20colorful%20background%20with%20candy%20and%20sweets%20floating%20cheerful%20vibrant%20atmosphere%20webtoon%20comedy&width=800&height=1067&seq=comic-cover-11&orientation=portrait',
    rating: 8.9,
    views: 14200000,
    chapters: 156,
    status: 'ongoing',
    description: '一个拥有超能力的甜点师女孩，做出的每一份甜品都能让人感受到幸福。她在一个偏僻的小镇开了一家甜品店，用魔法般的甜点治愈了每个来到店里的客人。',
    tags: ['搞笑', '美食', '治愈', '日常'],
    updatedAt: '2026-06-28',
  },
  {
    id: 12,
    title: '王朝风云',
    author: '墨染',
    category: 'historical',
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20Korean%20manhwa%20style%20illustration%20of%20a%20noblewoman%20in%20traditional%20Korean%20hanbok%20with%20intricate%20embroidery%20standing%20in%20an%20ancient%20palace%20courtyard%20with%20falling%20cherry%20blossoms%20elegant%20atmosphere%20soft%20traditional%20color%20palette%20detailed%20art&width=800&height=1067&seq=comic-cover-12&orientation=portrait',
    rating: 9.3,
    views: 21000000,
    chapters: 188,
    status: 'ongoing',
    description: '在朝鲜王朝时期，一位出身低微的女子凭借过人的智慧和胆识，一步步在宫廷权力斗争中崛起。她周旋于各方势力之间，用计谋改变了整个王朝的命运。',
    tags: ['历史', '宫廷', '权谋', '成长'],
    updatedAt: '2026-06-30',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小棉花糖',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20person%20avatar%20portrait%20with%20warm%20smile%20soft%20lighting%20Korean%20style%20minimal%20cream%20background%20friendly%20expression%20casual%20vibe&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '资深漫迷 · 5年粉龄',
    rating: 5,
    content: '韩漫网真的是我用过最良心的漫画网站！更新速度超级快，画质也很清晰。最重要的是完全免费，不用看广告。每天追更已经成为我生活的一部分了！',
  },
  {
    id: 2,
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20adult%20portrait%20avatar%20with%20glasses%20gentle%20smile%20intellectual%20vibe%20clean%20minimal%20background%20warm%20tone%20Korean%20style%20casual%20look&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '上班族 · 忠实用户',
    rating: 5,
    content: '上班摸鱼的时候最喜欢偷偷看韩漫，分类特别详细，找漫画超方便。推荐给了好几个同事，现在大家午休都在看哈哈。收藏功能也很好用！',
  },
  {
    id: 3,
    name: '漫画猎人',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20man%20portrait%20avatar%20with%20bright%20smile%20energetic%20expression%20casual%20hoodie%20clean%20background%20warm%20lighting%20Korean%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '大学生 · 漫画达人',
    rating: 5,
    content: '资源太全了！很多在其他平台找不到的冷门韩漫这里都有。而且阅读体验超流畅，翻页一点都不卡。已经安利给全宿舍了，都成了忠实用户。',
  },
  {
    id: 4,
    name: '月光下的猫',
    avatar: 'https://readdy.ai/api/search-image?query=Gentle%20young%20woman%20portrait%20avatar%20with%20soft%20smile%20long%20hair%20dreamy%20expression%20cozy%20sweater%20minimal%20cream%20background%20warm%20lighting%20Korean%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '自由职业 · 3年用户',
    rating: 5,
    content: '画质真的很棒，排版也特别舒服。界面简洁大方，没有乱七八糟的广告弹窗。每天晚上躺在床上看两话韩漫，是一天中最治愈的时刻。',
  },
  {
    id: 5,
    name: '追风少年',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20man%20portrait%20avatar%20with%20confident%20expression%20stylish%20casual%20look%20clean%20minimal%20background%20warm%20tone%20Korean%20style%20modern%20vibe&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '高中生 · 追漫达人',
    rating: 4,
    content: '更新速度没得说，基本和韩国同步。分类筛选功能特别好用，想看什么类型一目了然。如果能有APP版本就更好了，不过网页版也已经很流畅了！',
  },
  {
    id: 6,
    name: '咖啡不加糖',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20young%20woman%20portrait%20avatar%20with%20calm%20expression%20minimal%20makeup%20professional%20look%20simple%20background%20warm%20neutral%20tone%20Korean%20style&width=120&height=120&seq=avatar-06&orientation=squarish',
    role: '设计师 · 资深漫迷',
    rating: 5,
    content: '作为设计师，我特别欣赏韩漫网的UI设计，简洁优雅又不失温馨感。阅读体验非常好，书架功能也很实用。强烈推荐给所有喜欢韩漫的朋友！',
  },
];

export const heroSlides = [
  {
    id: 1,
    comicId: 2,
    title: '我独自升级',
    subtitle: '从最弱到最强，一人成军的传奇之路',
    description: '年度最热韩漫，全球阅读量突破5亿！见证最弱猎人如何逆袭成为不败传说。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20atmosphere%20with%20subtle%20purple%20and%20black%20energy%20waves%20abstract%20geometric%20patterns%20floating%20particles%20dramatic%20lighting%20Korean%20manhwa%20inspired%20art%20style%20deep%20shadows%20mysterious%20mood%20clean%20gradient%20background&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    tag: '热门推荐',
    rating: 9.8,
  },
  {
    id: 2,
    comicId: 3,
    title: '全知读者视角',
    subtitle: '当你知道这个世界的一切秘密',
    description: '现象级韩漫改编，唯一读者如何在末世中掌握命运。超高口碑，不可错过！',
    image: 'https://readdy.ai/api/search-image?query=Mystical%20fantasy%20atmosphere%20with%20golden%20light%20rays%20breaking%20through%20dark%20clouds%20ancient%20book%20pages%20floating%20in%20the%20air%20ethereal%20glowing%20symbols%20warm%20amber%20and%20deep%20teal%20color%20scheme%20Korean%20manhwa%20inspired%20dramatic%20cinematic%20feel&width=1600&height=1067&seq=hero-slide-02&orientation=landscape',
    tag: '编辑精选',
    rating: 9.7,
  },
  {
    id: 3,
    comicId: 5,
    title: '剑尊归来',
    subtitle: '重生少年，一剑破万法',
    description: '武侠与韩漫的完美融合，重生剑尊的复仇与救赎之旅。画面精美绝伦！',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20martial%20arts%20atmosphere%20with%20crimson%20and%20gold%20brush%20stroke%20patterns%20cherry%20blossom%20petals%20falling%20against%20dark%20background%20elegant%20traditional%20Korean%20art%20inspired%20design%20dynamic%20energy%20flow%20cinematic%20composition&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    tag: '新作推荐',
    rating: 9.6,
  },
];

export const latestUpdates = [
  {
    id: 1,
    comicTitle: '我独自升级',
    chapterNumber: 179,
    chapterTitle: '最终话：新的开始',
    updatedAt: '2小时前',
    comicId: 2,
  },
  {
    id: 2,
    comicTitle: '全知读者视角',
    chapterNumber: 210,
    chapterTitle: '第210话：最后的方案',
    updatedAt: '3小时前',
    comicId: 3,
  },
  {
    id: 3,
    comicTitle: '社内恋爱',
    chapterNumber: 112,
    chapterTitle: '第112话：意外的告白',
    updatedAt: '5小时前',
    comicId: 9,
  },
  {
    id: 4,
    comicTitle: '剑尊归来',
    chapterNumber: 145,
    chapterTitle: '第145话：剑意大成',
    updatedAt: '6小时前',
    comicId: 5,
  },
  {
    id: 5,
    comicTitle: '谁让我是绝世小可爱',
    chapterNumber: 189,
    chapterTitle: '第189话：心动的信号',
    updatedAt: '8小时前',
    comicId: 4,
  },
  {
    id: 6,
    comicTitle: '恶魔的契约',
    chapterNumber: 201,
    chapterTitle: '第201话：第七个任务',
    updatedAt: '10小时前',
    comicId: 10,
  },
  {
    id: 7,
    comicTitle: '幽灵医生',
    chapterNumber: 98,
    chapterTitle: '第98话：真相浮现',
    updatedAt: '12小时前',
    comicId: 8,
  },
  {
    id: 8,
    comicTitle: '女神降临',
    chapterNumber: 256,
    chapterTitle: '番外篇：十年之后',
    updatedAt: '1天前',
    comicId: 1,
  },
  {
    id: 9,
    comicTitle: '秘密课堂',
    chapterNumber: 167,
    chapterTitle: '第167话：正义的代价',
    updatedAt: '1天前',
    comicId: 7,
  },
  {
    id: 10,
    comicTitle: '甜蜜暴击',
    chapterNumber: 156,
    chapterTitle: '第156话：幸福的味道',
    updatedAt: '1天前',
    comicId: 11,
  },
];

export const siteInfo = {
  name: '韩漫网',
  tagline: '免费韩漫随心畅读',
  description: '韩漫网是国内领先的免费韩漫在线阅读平台，致力于为广大漫画爱好者提供最新、最全、最高清的韩国漫画资源。我们拥有海量漫画大全，涵盖恋爱、奇幻、动作、悬疑、搞笑等多种类型，每日同步更新，让您轻松畅享韩国漫画的精彩世界。',
  establishedYear: 2019,
  totalComics: '15,000+',
  totalUsers: '5,800,000+',
  dailyVisits: '320,000+',
  updateFrequency: '每日同步更新',
};